<template>
  <div class="review-slider-card">
    <review-card
      :default-sogu-fields="defaultSoguFields"
      :review="props.review"
      :is-disabled-expand="props.isDisabledExpand"
      v-bind="$attrs"
    />
  </div>
</template>

<script setup lang="ts">
  import ReviewCard from './ReviewCard.vue';
  import type { ReviewCardProps } from '@/entities/review';

  const props = withDefaults(defineProps<ReviewCardProps>(), {
    isDisabledExpand: false,
    options: () => ({
      maxTitleLines: 3,
      maxLines: 6,
    }),
  });
</script>

<style scoped lang="scss">
  @use '@experience/shared/dist/assets/adaptivity' as adaptivity;

  .review-slider-card {
    --card-height: 376px;
    overflow: hidden;
    height: var(--card-height);
    padding: var(--alias-space-16);
    border-radius: var(--alias-radius-8);
    background-color: var(--alias-color-background-subtle);
    container-type: inline-size;
    container-name: review-card-container;

    @media screen and (max-width: 360px) {
      --card-height: 376px;
      min-width: 256px;
      max-width: 290px;
    }

    @media screen and (min-width: 361px) {
      --card-height: 320px;
    }
  }

  :deep(.review-card) {
    padding: 0 !important;
  }

  :deep(.review-card__more-button) {
    --background: var(--alias-color-background-subtle);
  }

  :deep(.gallery-trigger) {
    margin-top: 16px !important;
    margin-bottom: 0;
  }
</style>
